import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  superBatchModules: null,
  selectedSuperBatchModule: null,
  deleteSuperBatchModuleModalState: false,
  updateSuperBatchModuleStatusModalState: false,
  updateSuperBatchModuleOrderModalState: false,
  updateSuperBatchModuleIntrviewModalState: false,
  addSuperBatchModuleModalState: false,
  superBatchModuleError: null,
};

export const superBatchModule = createSlice({
  name: 'superBatchModule',
  initialState,
  reducers: {
    setSuperBatchModules: (state, action) => {
      state.superBatchModules = action.payload;
    },
    setDeleteSuperBatchModuleModalState: (state, action) => {
      state.deleteSuperBatchModuleModalState = action.payload;
    },
    setSelectedSuperBatchModule: (state, action) => {
      state.selectedSuperBatchModule = action.payload;
    },
    setUpdateSuperBatchModuleModalState: (state, action) => {
      state.updateSuperBatchModuleStatusModalState = action.payload;
    },
    setUpdateSuperBatchModuleOrderModalState: (state, action) => {
      state.updateSuperBatchModuleOrderModalState = action.payload;
    },
    setUpdateSuperBatchModuleInterviewModalState: (state, action) => {
      state.updateSuperBatchModuleIntrviewModalState = action.payload;
    },
    setAddSuperBatchModuleModalState: (state, action) => {
      state.addSuperBatchModuleModalState = action.payload;
    },
    setSuperBatchModuleErrors: (state, action) => {
      state.superBatchModuleError = action.payload;
    },
  },
});

export const {
  setAddSuperBatchModuleModalState,
  setDeleteSuperBatchModuleModalState,
  setSelectedSuperBatchModule,
  setSuperBatchModuleErrors,
  setSuperBatchModules,
  setUpdateSuperBatchModuleInterviewModalState,
  setUpdateSuperBatchModuleModalState,
  setUpdateSuperBatchModuleOrderModalState,
} = superBatchModule.actions;
export default superBatchModule.reducer;
